import React, { useState } from 'react'
import './styles.css'
import { ScheduleTabsProps } from '../../../interfaces/props/ScheduleTabsProps';
import { TypeScheduleTabsEnum } from '../../../interfaces/enum/TypeScheduleTabsEnum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck } from '@fortawesome/free-solid-svg-icons';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import ModalAction from '../../../components/ModalAction';

function ScheduleTabs(props: ScheduleTabsProps) {

  const accessibility = useAccessibility();
  const font14Style = accessibility.calculateTextStyle(14)

  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string; title: string; subTitle?: string;
    handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon?: "error" | "success" | "warning"
  }>(null);

  const openModalAction = (
    title: string, subTitle: string, textOutlinedButton: string, textContainedButton: string,
    handleOutlinedButton?: () => void, handleContainedButton?: () => void, icon?: "error" | "success" | "warning"
  ) => {
    setModalAction({
      title: title,
      subTitle: subTitle,
      textOutlinedButton: textOutlinedButton,
      textContainedButton: textContainedButton,
      handleContainedButton: handleContainedButton,
      handleOutlinedButton: handleOutlinedButton,
      handleShowModal: closeModalAction,
      icon: icon || 'warning'
    })
  }

  const closeModalAction = () => {
    setModalAction(null);
  }

  const isChecked = (step: TypeScheduleTabsEnum): boolean => {
    switch (step) {
      case TypeScheduleTabsEnum.GuiaMedico:
        return props.step !== TypeScheduleTabsEnum.GuiaMedico
      case TypeScheduleTabsEnum.Horario:
        return props.step === TypeScheduleTabsEnum.LocalDeExames || props.step === TypeScheduleTabsEnum.Confirmacao
      case TypeScheduleTabsEnum.LocalDeExames:
        return props.step === TypeScheduleTabsEnum.Confirmacao
      default:
        return false
    }
  }

  const handleClick = (step: TypeScheduleTabsEnum) => {
    if (isChecked(step)) {
      openModalAction('Atenção!', 'Ao retornar para a página solicitada, os dados preenchidos serão desconsiderados. Deseja continuar?', 'Não', 'Sim', 
          () => { closeModalAction() },
          () => { setModalAction(null); props.backStep(step, false); });
    }
  }


  return (
    <div className='schedule-tabs-holder'>
      <div className="schedule-slider">
        <div style={{ background: accessibility.contrastMode ? accessibility.contrastColor : '' }} className={`schedule-progress ${props.step}`}/>
      </div>
      <div className="schedule-tabs">
        <div 
          onClick={() => handleClick(TypeScheduleTabsEnum.GuiaMedico)}
          onKeyDown={e => { if (e.key === 'Enter') { handleClick(TypeScheduleTabsEnum.GuiaMedico)}}}
          tabIndex={isChecked(TypeScheduleTabsEnum.GuiaMedico) ? 0 : -1}
          className={`schedule-tab ${isChecked(TypeScheduleTabsEnum.GuiaMedico) ? 'checked' : ''}`}>
          <div className="schedule-tab-icon-holder">
            {props.step === TypeScheduleTabsEnum.GuiaMedico ?
              <span className={`${TypeScheduleTabsEnum.GuiaMedico && (accessibility.contrastMode ? 'current-tab-accessibility' : 'current-tab')}`}>1</span> :
              <div className="check-icon">
                <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCheck} size='xs'/>
              </div>
            }
          </div>
          <span style={font14Style}>Guia Médico</span>
        </div>
        <div
          onClick={() => handleClick(TypeScheduleTabsEnum.Horario)} 
          onKeyDown={e => { if (e.key === 'Enter') { handleClick(TypeScheduleTabsEnum.Horario)}}}
          tabIndex={isChecked(TypeScheduleTabsEnum.Horario) ? 0 : -1}
          className={`schedule-tab ${isChecked(TypeScheduleTabsEnum.Horario) ? 'checked' : ''}`}>
          <div className="schedule-tab-icon-holder">
            {props.step !== TypeScheduleTabsEnum.LocalDeExames && props.step !== TypeScheduleTabsEnum.Confirmacao ?
              <span className={`${props.step === TypeScheduleTabsEnum.Horario && (accessibility.contrastMode ? 'current-tab-accessibility' : 'current-tab')}`}>2</span> :
              <div className="check-icon">
                <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCheck} size='xs'/>
              </div>
            }
          </div>
          <span style={font14Style}>Horário</span>
        </div>
        <div
          onClick={() => handleClick(TypeScheduleTabsEnum.LocalDeExames)} 
          onKeyDown={e => { if (e.key === 'Enter') { handleClick(TypeScheduleTabsEnum.LocalDeExames)}}}
          tabIndex={isChecked(TypeScheduleTabsEnum.LocalDeExames) ? 0 : -1}
          className={`schedule-tab ${isChecked(TypeScheduleTabsEnum.LocalDeExames) ? 'checked' : ''}`}>
          <div className="schedule-tab-icon-holder">
            {props.step !== TypeScheduleTabsEnum.Confirmacao ?
              <span className={`${props.step === TypeScheduleTabsEnum.LocalDeExames && (accessibility.contrastMode ? 'current-tab-accessibility' : 'current-tab')}`}>3</span> :
              <div className="check-icon">
                <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCheck} size='xs'/>
              </div>
            }
          </div>
          <span style={font14Style}>Local de exames</span>
        </div>
        <div
          onClick={() => handleClick(TypeScheduleTabsEnum.Confirmacao)} 
          className={`schedule-tab ${isChecked(TypeScheduleTabsEnum.Confirmacao) ? 'checked' : ''}`}>
          <div className="schedule-tab-icon-holder">
            <span className={`${props.step === TypeScheduleTabsEnum.Confirmacao && (accessibility.contrastMode ? 'current-tab-accessibility' : 'current-tab')}`}>4</span>
          </div>
          <span style={font14Style}>Confirmação</span>
        </div>
      </div>
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        icon={modalAction?.icon}
        textOutlinedButton={modalAction?.textOutlinedButton || ''}
        textContainedButton={modalAction?.textContainedButton || ''}
        title={modalAction?.title || ''}
        subTitle={modalAction?.subTitle || ''}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
      />
    </div>
  )
}

export default ScheduleTabs